/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import IbdDiskSurveyFilledJournalEvent from "parog-web/models/ibd-disk-survey-filled-journal-event";
import type SemeiaSessionService from "parog-web/services/session";
import MiciBaseEditionFormEditionForm from "../base-edition-form/edition-form";

export default class MiciIbdDiskSurveyEditionForm extends MiciBaseEditionFormEditionForm {
  static forcDisplayName = "Questionnaire IBD-Disk";
  static fullComponentId = "mici/ibd-disk-survey-edition-form";

  static journalEventClass = IbdDiskSurveyFilledJournalEvent;

  @service declare session: SemeiaSessionService;

  get forcDisplayName(): string {
    return this.session.medic ? "Questionnaire IBD-Disk" : "Qualité de vie";
  }

  get currentSections(): Array<string> {
    return IbdDiskSurveyFilledJournalEvent.sections;
  }
}
